import service from '@/middleware'

const personApi = {

    /**
     * Datos para la tabla del ABM
     * @param {*} pageSize
     * @param {*} pageNumber
     * @param {*} headers si hay que devolver o no el arreglo con los headers de la tabla
     * @param {*} enterpriseIds
     */
    async findAll(pageSize, pageNumber, headers = false, enterpriseIds) {
        const url = pageSize != null && pageNumber != null
            ? `/api/person/all?pageSize=${pageSize}&pageNumber=${pageNumber}&headers=${headers}`
            : `/api/person/all?headers=${headers}`
        const response = await service.http.post(url, enterpriseIds)
        return response
    },

    /**
     * Total de personas de la collection (para el paginador)
     */
    async getTotal (enterpriseIds) {
        const response = await service.http.post(`/api/person/total`, enterpriseIds)
        return response
    },

    /**
     * Para crear una nueva persona
     * @param {*} person
     * @param {*} personIdDriverCodeUnset
     */
    async create (person, personIdDriverCodeUnset) {
        let url = `/api/person/create`
        if (personIdDriverCodeUnset) {
            url = `${url}?personIdDriverCodeUnset=${personIdDriverCodeUnset}`;
        }
        const result = await service.http.post(url, person)
        return result
    },

    /**
     * Para actualizar una persona
     * @param {*} person
     * @param {*} personIdDriverCodeUnset
     */
    async update (person, personIdDriverCodeUnset) {
        let url = `/api/person/update`
        if (personIdDriverCodeUnset) {
            url = `${url}?personIdDriverCodeUnset=${personIdDriverCodeUnset}`;
        }
        const result = await service.http.put(url, person)
        return result
    },

    /**
     * Para eliminar una persona
     * @param {*} id
     */
    async deleteOne (id) {
        const result = await service.http.delete(`/api/person/delete/${id}`)
        return result
    },

    /**
     * Para elminación múltiple
     * @param {*} ids
     */
    async deleteMany (ids) {
        const result = await service.http.put(`/api/person/multiple-delete`, ids)
        return result
    },

    /**
     * Estados civiles para el selector del ABM
     */
    async getCivilStatus () {
        const response = await service.http.get(`/api/person/civil-status`)
        return response
    },

    /**
     * Datos de una persona a partir de su id
     * @param {*} id
     */
    async findOneById (id) {
        const response = await service.http.get(`/api/person/one-by-id/${id}`)
        return response
    },

    /**
     * Selector de conductores de scoring
     * @param {*} enterpriseIds
     */
    async getDriverSelector (enterpriseIds) {
        return await service.http.post(`/api/person/driver-selector`, enterpriseIds);
    },

    /**
     * Para validar el driverCode en el ABM de personas
     * @param {*} driverCode
     */
    async validateDriverCode (driverCode, id) {
        let url = `/api/person/validate-driver-code/${driverCode}`
        if (id) {
            url = `${url}?id=${id}`;
        }
        return await service.http.get(url);
    }

}

export default personApi
